export const FETCH_RELEASES_REQUEST = 'FETCH_RELEASES_REQUEST';
export const FETCH_RELEASES_SUCCESS = 'FETCH_RELEASES_SUCCESS';
export const FETCH_RELEASES_FAILURE = 'FETCH_RELEASES_FAILURE';

export const FETCH_RELEASE_REQUEST = 'FETCH_RELEASE_REQUEST';
export const FETCH_RELEASE_SUCCESS = 'FETCH_RELEASE_SUCCESS';
export const FETCH_RELEASE_FAILURE = 'FETCH_RELEASE_FAILURE';

export const UPDATE_RELEASES_REQUEST = 'UPDATE_RELEASES_REQUEST';
export const UPDATE_RELEASES_SUCCESS = 'UPDATE_RELEASES_SUCCESS';
export const UPDATE_RELEASES_FAILURE = 'UPDATE_RELEASES_FAILURE';

export const DELETE_RELEASES_REQUEST = 'DELETE_RELEASES_REQUEST';
export const DELETE_RELEASES_SUCCESS = 'DELETE_RELEASES_SUCCESS';
export const DELETE_RELEASES_FAILURE = 'DELETE_RELEASES_FAILURE';

export const OPEN_EDIT_RELEASE_PAGE = 'OPEN_EDIT_RELEASE_PAGE';
export const OPEN_EDIT_RELEASE_PAGE_SUCCESS = 'OPEN_EDIT_RELEASE_PAGE_SUCCESS';

export const CLEAR_RELEASE_ERRORS = 'CLEAR_RELEASE_ERRORS';
export const CLEAR_RELEASE_SUCCESS = 'CLEAR_RELEASE_SUCCESS';